import { AppImages } from "app/appImages";
import { TrainingContentType } from "generated/CoreApi_v1";
import * as React from "react";

/////////////////////////////////////////////////////////////////////////////////////

interface IPropsImage {
    contentType: TrainingContentType;
    thumbnailUrl?: string | null;
    width?: number | string;
    height?: number | string;
}

/////////////////////////////////////////////////////////////////////////////////////

export function LmsTrainingDefaultThumbnailUrl(contentType?: TrainingContentType, thumbnailUrl?: string | null) {

    const url = thumbnailUrl
        ? thumbnailUrl
        : contentType == TrainingContentType.ExternalCourse
            ? AppImages.LmsContentTypeExternalCourseThumbnail
            : contentType == TrainingContentType.LearnPath || contentType == TrainingContentType.Game
                ? AppImages.LmsContentTypeLearnPathThumbnail
                : contentType == TrainingContentType.Evaluation
                    ? AppImages.LmsContentTypeEvaluationThumbnail
                    : contentType == TrainingContentType.LiveMix || contentType == TrainingContentType.LiveOnline || contentType == TrainingContentType.LivePresential
                        ? AppImages.LmsContentTypeLiveOnLineThumbnail
                        : AppImages.LmsContentTypeCourseWebThumbnail;

    return url;
}

export const LmsTrainingImage: React.FC<IPropsImage> = (props) => {
    const { contentType, thumbnailUrl, width, height } = props;
    const url = LmsTrainingDefaultThumbnailUrl(contentType, thumbnailUrl);

    return (
        <img
            src={url}
            width={width}
            height={height}
            style={{ borderRadius: 8 }}
        />
    );
};
